import React, { useEffect, useState } from "react";
import ActiveDriversLocationsMap from "./components/ActiveDriversLocationsMap";
import HeatMapRideDemandMap from "./components/HeatMapRideDemandMap";
// import 'bootstrap/dist/css/bootstrap.min.css';
import Table from "./components/Table";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { API_URL } from "./components/config"; // Ensure this is the correct import

// -------------------- JWT Authentication -------------------- 
import { AuthProvider } from "./components/auth/AuthProvider";
import CustomersTable from "./components/CustomersTable";
import DriversTable from "./components/DriversTable";
import SearchPage from "./components/searchPage";
import Billing from "./components/Billing";
import AddTopUp from "./components/from tellthem/AddTopUp";
import AdminDashboard from "./components/from tellthem/AdminDashboard";
import axios from "axios";
import PendingReg from "./components/from tellthem/PendingRegistrations";
import SearchTrip from "./components/searchTrip";
import Analytics from "./components/Analytics";
import EnhancedPromotions from "./components/EnhancedPromotions";
import ReferralTracking from "./components/ReferralTracking";
import ChannelAttribution from "./components/ChannelAttribution";
import Broadcast from "./components/Broadcast";
import CustomerAdminChat from "./components/CustomerAdminChat";
import ChatHome from "./components/ChatHome";
import Feedback from "./components/feedback";
import Funnel from "./components/funnel";
import AddConfig from "./components/AddConfig";
import AppStatistics from "./components/AppStatistics";
import ViewConfig from "./components/ViewConfig";
import Configurations from "./components/Configurations";
import MapView from "./components/Location";
import MapViewWithDriver from "./components/TripTrack";
import ReportAnalysis from "./components/reportAnalysis";
import TopTwentyDrivers from "./components/Top&BottomMembers/TopDrivers";
//TopUp
import User from "./TopUp/user";
import Vendor from "./TopUp/vendor";
import TopUpHome from "./TopUp/TopUpHome";

import Home from "./components/Home";
import Confirmation from "./components/ConfirmPage";
import Map from "./components/MapPointer";
import Maps from "./components/Maps";
//dashboard statistcis
import Statistics from "./DashboardStats/Statistics";
import NotificationAnalytics from "./components/NotificationAnalytics";

import DashTracker from "./components/DashTracker";
import Track from "./components/Track";
import AppDownloadAnalytics from "./components/AppDownloadAnalytics";
import Driversdisplay from "./components/Driversdisplay";
import ChartDashboard from "./components/ChartHome";
import Chart from "./components/ChartScreen";
import StsDashboard from "./DashboardStats/StatsComponents/cards/Sts";
import Hourly from "./DashboardStats/hourlyStats";
import BillingStats from "./DashboardStats/StatsComponents/BillingStats";
import FunnelStats from "./DashboardStats/StatsComponents/FunnelStats";
import WaitTimeMonitor from "./components/WaitTimeMonitor";
import TransactionTable from "./DashboardStats/StatsComponents/TransactionTable";
import GroupedTransactionTable from "./DashboardStats/StatsComponents/GroupedTransactionTable";
import AllocateCharts from "./TicketsHandling/AllocateCharts";
// import AdminChats from './TicketsHandling/ChartHome';
import CustomerServiceHome from "./TicketsHandling/CustomerServiceHome";
import ChatScreen from "./TicketsHandling/Chart";
import AllocateTicket from "./TicketsHandling/AllocateTickets";
import TicketManagement from "./TicketsHandling/TicketComplete";
import UserAllocatedTickets from "./TicketsHandling/TechSupportHome";
import AssignmentSettingsPage from "./TicketsHandling/AssignmentSettingsPage";
// import Login from "./TicketsHandling/CustomerServiceLogin";
import JobTitleSubmissionPage from "./OnBoarding/RegisterJobTitles";
import RegisterEmployee from "./OnBoarding/RegisterEmployee";
import Login from "./Login";
import HrDashboard from "./OnBoarding/HrServicesHome";
import TerminateUser from "./OnBoarding/TerminateUser";
import AllTicket from "./TicketsHandling/AllTickects";
import TicketPage from "./TicketsHandling/TickectProgress";
import Customers from "./components/Customers";
import Drivers from "./components/Drivers";
import Trips from "./components/Trips";
// import DriverAdvancePage from "./components/from tellthem/AdvanceDriver";
import TicketCreationPage from "./TicketsHandling/AddTicket";
import BroadcastCust from "./components/BroadcastCust";
import AllocateTrips from "./components/AllocateTrips";
import TopTwentyCustomers from "./components/Top&BottomMembers/TopCustomers";
import LowestTwentyCustomers from "./components/Top&BottomMembers/LowerCustomers";
import LowestTwentyDrivers from "./components/Top&BottomMembers/LowerDrivers";
import PerformanceReports from "./components/Reports/PerformanceReports";
import TripsStatusReport from "./components/Reports/TripsStatusReport";
import GeographicReport from "./components/Reports/GeographicReport";
import PeakHoursReport from "./components/Reports/PeakHoursReport";
import RevenueBreakdownReport from "./components/Reports/RevenueBreakdownReport";
import DriverPerformanceReport from "./components/Reports/DriverPerformanceReport";
import CustomerAnalyticsDashboard from './components/CustomerAnalyticsDashboard';
import EnhancedDriverAnalyticsDashboard from './components/EnhancedDriverAnalyticsDashboard';
import ComprehensiveAnalyticsDashboard from './components/ComprehensiveAnalyticsDashboard';
import RideshareAnalyticsReport from "./components/Reports/RideshareAnalyticsReport";
import PrivateRideAnalyticsReport from "./components/Reports/PrivateRideAnalyticsReport";
import CustomersMap from "./components/CustomersMap";
// Commission System Components
import RealtimeSettings from "./components/RealtimeSettings";
import DetourDistanceControl from "./components/DetourDistanceControl";
import NotificationSettingsControl from "./components/NotificationSettingsControl";
import BotGreetingsControl from "./components/BotGreetingsControl";
import ReferralMessagesControl from "./components/ReferralMessagesControl";
import DriverEarningsPanel from "./components/DriverEarningsPanel";
import CustomerPerformancePanel from "./components/CustomerPerformancePanel";
import CustomerPerformanceReport from "./components/Reports/CustomerPerformanceReport";
import CustomerAnalyticsReport from "./components/Reports/CustomerAnalyticsReport";
import DashboardLayout from "./components/DashboardLayout/DasboardLayout";
// Enhanced Promotion System
// Withdrawal Management System
import WithdrawalManagementPanel from './components/WithdrawalManagementPanel';
import PaymentReconciliationPanel from './components/PaymentReconciliationPanel';
// Vehicle Rental Management System
import VehicleOwnershipSettings from './components/VehicleOwnershipSettings';
import DriveToOwnApplications from './components/DriveToOwnApplications';
import TellerControlPanel from './components/TellerControlPanel';
import DriverConfigurationManagement from './components/DriverConfigurationManagement';
import VehicleManagement from './components/VehicleManagement';
import FinancialSystemGuide from './components/FinancialSystemGuide';
import FinancialOverview from './components/FinancialOverview';
import FAQManagement from './FAQManagement/FAQManagement';
import RoadAssistanceManagement from './RoadAssistance/RoadAssistanceManagement';
import ImageGallery from './components/ImageGallery';

function App() {
  const [tripData, setTripData] = useState([]);
  const [customersData, setCustomersData] = useState([]);
  const [driversData, setDriversData] = useState([]);
  const APILINK = API_URL;

  const getDrivers = async () => {
    try {
      const response = await fetch(`${APILINK}/driver/`);
      const data = await response.json();
      console.log(data);
      setDriversData(data);
    } catch (error) {
      console.log(error);
    }
  };

  const getCustomers = async () => {
    try {
      const response = await axios.get(`${APILINK}/customerdetails/`);
      const data = response.data;
      console.log(data);
      setCustomersData(data);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const fetchTripData = async () => {
    try {
      const response = await fetch(`${API_URL}/trip/`);
      const data = await response.json();
      setTripData(data);
    } catch (error) {
      console.error("Error fetching trip data:", error);
    }
  };

  useEffect(() => {
    fetchTripData();
    getCustomers();
    getDrivers();
  }, []);

  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Routes>
          <Route index element={<Login />} />
          <Route path="/trips" element={<Table />} />
          <Route path="/active-drivers-locations-map" element={<ActiveDriversLocationsMap />} />
          <Route
            path="/Driverstable/list"
            element={<DriversTable driversData={driversData} />}
          />
          <Route
            path="/Customerstable/list"
            element={<CustomersTable customersData={customersData} />}
          />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/toptwentydriverscount" element={<TopTwentyDrivers />} />
          <Route path="/toptwentycustomerscount" element={<TopTwentyCustomers />} />
          <Route path="/performance-reports" element={<PerformanceReports />} />
          <Route path="/trips-status-report" element={<TripsStatusReport />} />
          <Route path="/geographic-report" element={<GeographicReport />} />
          <Route path="/peak-hours-report" element={<PeakHoursReport />} />
          <Route path="/revenue-breakdown-report" element={<RevenueBreakdownReport />} />
          <Route path="/driver-performance-report" element={<DriverPerformanceReport />} />
          <Route path="/rideshare-analytics-report" element={<RideshareAnalyticsReport />} />
          <Route path="/private-ride-analytics-report" element={<PrivateRideAnalyticsReport />} />
          <Route path="/wait-time-monitor" element={<WaitTimeMonitor />} />
          <Route path="/customer-analytics-dashboard" element={
            <DashboardLayout>
              <CustomerAnalyticsDashboard />
            </DashboardLayout>
          } />
          <Route path="/driver-analytics-dashboard" element={
            <DashboardLayout>
              <EnhancedDriverAnalyticsDashboard />
            </DashboardLayout>
          } />
          <Route path="/enhanced-driver-analytics" element={
            <DashboardLayout>
              <EnhancedDriverAnalyticsDashboard />
            </DashboardLayout>
          } />
          <Route path="/comprehensive-analytics" element={
            <DashboardLayout>
              <ComprehensiveAnalyticsDashboard />
            </DashboardLayout>
          } />
          <Route path="/lowtwentydriverscount" element={<LowestTwentyDrivers />} />
          <Route path="/lowtwentycustomerscount" element={<LowestTwentyCustomers />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/TripAllocate" element={<AllocateTrips/>} />
          <Route path="/AddTopUp" element={<AddTopUp />} />
          <Route path="/broadcast" element={<Broadcast />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/enhanced-promotions" element={<EnhancedPromotions />} />
          <Route path="/referral-tracking" element={<ReferralTracking />} />
          <Route path="/channel-attribution" element={<ChannelAttribution />} />
          <Route path="/Admindash" element={<AdminDashboard />} />
          <Route path="/verifyReg" element={<PendingReg />} />
          <Route path="/searchTrip" element={<SearchTrip />} />
          <Route path="/chatNow/:tripId" element={<CustomerAdminChat />} />
          <Route path="/chatHome" element={<ChatHome />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/funnel" element={<Funnel />} />
          <Route path="/AddConfig" element={<AddConfig />} />
          <Route path="/AppStatistics" element={<AppStatistics />} />
          <Route path="/ViewConfig" element={<ViewConfig />} />
          <Route path="/Configurations" element={<Configurations />} />
          <Route path="/map" element={<MapView />} />
          <Route path="/mapWithDriver" element={<MapViewWithDriver />} />
          <Route path="/ReportAnalysis" element={<ReportAnalysis />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/Confirmation" element={<Confirmation />} />
          <Route path="/customers-map" element={<CustomersMap />} />
          <Route path="/active-drivers-locations-map" element={<ActiveDriversLocationsMap />} />
          <Route path="/heatmap-ride-demand" element={<HeatMapRideDemandMap />} />
          {/* Commission System Routes */}
          <Route path="/commission-control" element={
            <DashboardLayout>
              <RealtimeSettings />
            </DashboardLayout>
          } />
          <Route path="/detour-distance-control" element={
            <DashboardLayout>
              <DetourDistanceControl />
            </DashboardLayout>
          } />
          <Route path="/notification-settings" element={
            <DashboardLayout>
              <NotificationSettingsControl />
            </DashboardLayout>
          } />
          <Route path="/bot-greetings" element={
            <DashboardLayout>
              <BotGreetingsControl />
            </DashboardLayout>
          } />
          <Route path="/referral-messages" element={
            <DashboardLayout>
              <ReferralMessagesControl />
            </DashboardLayout>
          } />
          <Route path="/driver-earnings" element={
            <DashboardLayout>
              <DriverEarningsPanel />
            </DashboardLayout>
          } />
          <Route path="/customer-performance" element={
            <DashboardLayout>
              <CustomerPerformancePanel />
            </DashboardLayout>
          } />
          <Route path="/customer-performance-report" element={
            <DashboardLayout>
              <CustomerPerformanceReport />
            </DashboardLayout>
          } />
          {/* Withdrawal Management System */}
          <Route path="/withdrawal-management" element={
            <DashboardLayout>
              <WithdrawalManagementPanel />
            </DashboardLayout>
          } />
          {/* Payment Reconciliation System */}
          <Route path="/payment-reconciliation" element={
            <DashboardLayout>
              <PaymentReconciliationPanel />
            </DashboardLayout>
          } />
          {/* XGO Financial System guide — the one place that explains every subsystem, folio, and
              trxn_code in plain language. Purely reference content, no data fetching. Mirrors
              xgo_rideshare_backend/Documentation/FINANCIAL_SYSTEM.md; keep the two in sync. */}
          <Route
            path="/financial-system-guide"
            element={
              <DashboardLayout>
                <FinancialSystemGuide />
              </DashboardLayout>
            }
          />
          {/* Financial Overview — eagle-eye/panoramic live-data companion to the guide above.
              Stitches together 3 previously-unused platform-wide aggregate endpoints. */}
          <Route
            path="/financial-overview"
            element={
              <DashboardLayout>
                <FinancialOverview />
              </DashboardLayout>
            }
          />
          {/* Vehicle Ownership / Earnings Allocation Settings — real, live-wired (2026-09-15).
              (The old "Vehicle Rental Management" page that used to be here was 100% mock data
              sitting on top of a confirmed-broken legacy backend — removed 2026-09-15, see
              KNOWN_ISSUES_AND_FIX_BACKLOG.md.) */}
          <Route
            path="/vehicle-ownership-settings"
            element={
              <DashboardLayout>
                <VehicleOwnershipSettings />
              </DashboardLayout>
            }
          />
          {/* Drive to Own applications queue — real, live-wired (2026-09-15, see
              KNOWN_ISSUES_AND_FIX_BACKLOG.md #71) */}
          <Route
            path="/drive-to-own-applications"
            element={
              <DashboardLayout>
                <DriveToOwnApplications />
              </DashboardLayout>
            }
          />
          {/* Teller Operations Routes */}
          <Route
            path="/teller-control-panel"
            element={
              <DashboardLayout>
                <TellerControlPanel />
              </DashboardLayout>
            }
          />
          {/* Driver Configuration Routes */}
          <Route
            path="/driver-configuration"
            element={
              <DashboardLayout>
                <DriverConfigurationManagement />
              </DashboardLayout>
            }
          />
          {/* Vehicle Management Route */}
          <Route
            path="/vehicle-management"
            element={
              <DashboardLayout>
                <VehicleManagement />
              </DashboardLayout>
            }
          />
          {/* FAQ Management Route */}
          <Route
            path="/faq-management"
            element={
              <DashboardLayout>
                <FAQManagement />
              </DashboardLayout>
            }
          />
          <Route path="/customer-analytics-report" element={
            <DashboardLayout>
              <CustomerAnalyticsReport />
            </DashboardLayout>
          } />
          <Route path="/Map" element={<Map />} />
          <Route path="/Maps" element={<Maps />} />
          <Route path="/DashTracker/:tripId" element={<DashTracker />} />
          <Route path="/Track/:tripId" element={<Track />} />
          {/* Track2.js was a pure 11-line pass-through to DashTracker — removed 2026-09-14, route kept
              (in case any external link still points at it) and repointed straight at DashTracker */}
          <Route path="/Track2/:tripId" element={<DashTracker />} />
          <Route path="/Driversdisplay" element={<Driversdisplay />} />
          <Route path="/Drivers" element={<Drivers />} />
          <Route path="/Customers" element={<Customers />} />
          <Route path="/TripsFilter" element={<Trips />} />
          //Chart
          <Route path="/ChartScreen" element={<Chart />} />
          <Route path="/ChartHome" element={<ChartDashboard />} />
          // statistcis
          <Route path="/stats" element={<Statistics />} />
          <Route path="/statsCharts" element={<StsDashboard />} />
          <Route path="/hourly" element={<Hourly />} />
          <Route path="/billing-stats" element={<BillingStats />} />
          <Route path="/funnel-stats" element={<FunnelStats />} />
          <Route path="/notification-analytics" element={
            <DashboardLayout>
              <NotificationAnalytics />
            </DashboardLayout>
          } />
          <Route path="/app-download-analytics" element={
            <DashboardLayout>
              <AppDownloadAnalytics />
            </DashboardLayout>
          } />
          <Route path="/TransactionTable" element={<TransactionTable />} />
          <Route
            path="/GroupedTransactionTable"
            element={<GroupedTransactionTable />}
          />
          //TicketHandling
          <Route path="/TicketCreationPage" element={<TicketCreationPage />} />
          <Route path="/AllocateChats" element={<AllocateCharts />} />
          {/* <Route path="/AllocatedChats" element={<AdminChats />} /> */}
          <Route
            path="/CustomerServiceHome"
            element={<CustomerServiceHome />}
          />
          <Route
            path="/CustomerServiceChat/:id/:customerid"
            element={<ChatScreen />}
          />
          <Route path="/AllocateTickets" element={<AllocateTicket />} />
          <Route path="/TicketManagement/:id" element={<TicketManagement />} />
          <Route path="/Tickets" element={<UserAllocatedTickets />} />
          <Route path="/TechSupportHome" element={<UserAllocatedTickets />} />
          <Route path="/assignment-settings" element={
            <DashboardLayout>
              <AssignmentSettingsPage />
            </DashboardLayout>
          } />
          <Route path="/Login" element={<Login />} />
          //OnBoarding
          <Route
            path="/RegisterJobTitles"
            element={<JobTitleSubmissionPage />}
          />
          <Route path="/RegisterEmployee" element={<RegisterEmployee />} />
          <Route path="/HrHome" element={<HrDashboard />} />
          <Route path="/TerminateUser" element={<TerminateUser />} />
          <Route path="/AllTickets" element={<AllTicket />} />
          <Route path="/TicketProgress/:id" element={<TicketPage />} />
          //Vendor
          <Route path="/user/:userId" element={<User />} />
          <Route path="/vendor/:vendor_id" element={<Vendor />} />
          <Route path="/TopUpHome" element={<TopUpHome />} />
          {/*<Route path="/DriverAdvancePage" element={<DriverAdvancePage />} />*/}
          <Route
            path="/BroadcastCust"
            element={<BroadcastCust customersData={customersData} />}
           />
          <Route path="/road-assistance" element={<RoadAssistanceManagement />} />
          <Route path="/image-gallery" element={
            <DashboardLayout>
              <ImageGallery />
            </DashboardLayout>
          } />
        </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
